import React from 'react'
import styled, { css } from 'styled-components'
import { useAuth } from '../auth/useAuth'
import { Content, Footer, Navbar, WelcomeBar } from './shared'

export const OnboardingLayout = ({ children, skipGreeting = false }) => {
  const { isAuthenticated } = useAuth()

  return (
    <>
      <Root isAuthenticated={isAuthenticated} skipGreeting={skipGreeting}>
        <StyledNavbar hideNavContent />
        {isAuthenticated && !skipGreeting && <WelcomeBar />}
        <Content variant='narrow'>{children}</Content>
        <StyledFooter variant='minimal' />
      </Root>
    </>
  )
}

const commonStyles = () => css`
  max-width: 992px;
  padding: 0 16px !important;

  @media (max-width: 639px) {
    padding: 0 24px !important;
  }
`

const Root = styled.div`
  display: grid;
  grid-template-rows: ${({ isAuthenticated, skipGreeting }) =>
    isAuthenticated && !skipGreeting ? 'auto auto 1fr auto' : 'auto 1fr auto'};
  grid-template-columns: 100%;
  width: 100%;
  min-height: 100%;
  background: #f6f6f9;
`

const StyledNavbar = styled(Navbar)`
  background: #ffffff;

  .content {
    ${commonStyles}
  }
`

const StyledFooter = styled(Footer)`
  .content {
    ${commonStyles}
  }
`
